import { formControl, FormControlExtended } from '@al00x/forms';
import { Component, computed, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CacCheckboxComponent } from "@controladad/ng-base";

export interface PermissionBox {
  label: string;
  hasSelectAll?: boolean;
  items: {
    label: string;
    key: string;
    id: number;
    control: FormControlExtended<boolean>;
  }[];
}

@Component({
  selector: 'app-permission-box',
  imports: [CacCheckboxComponent],
  templateUrl: './permission-box.component.html',
  styleUrl: './permission-box.component.scss'
})
export class PermissionBoxComponent implements OnInit {
  data = input.required<PermissionBox>();

  selectAllControl: FormControlExtended = formControl<boolean>(false);

  allSelected = computed(() => {
    const items = this.data().items;
    return items.length > 0 && items.every(item => item.control.value === true);
  });

  constructor() {
    this.selectAllControl.valueChanges.pipe(takeUntilDestroyed())
      .subscribe(checked => {
        this.data().items.forEach(item => {
          item.control.setValue(checked);
        });
      });
  }

  ngOnInit(): void {
    this.updateSelectAll();
  }

  updateSelectAll() {
    const items = this.data().items;
    const isAllSelected = items.length > 0 && items.every(item => item.control.value === true);
    this.selectAllControl.setValue(isAllSelected, { emitEvent: false });
  }

}
